<template>
  <div class="wrap">
    <v-card-title class="d-flex justify-space-between">
      <span class="headline">Редактирование формы</span>
      <router-link
        :to="
          `/forms/results?landing_id=${getCurrentLandingId()}&form_id=${this.getFormId()}`
        "
      >
        <v-btn color="primary">Результаты формы</v-btn>
      </router-link>
    </v-card-title>
    <v-card-text>
      <Form @submit="update" :formData="formData" />
    </v-card-text>
    <v-snackbar v-model="snackbar" :multi-line="multiLine" color="red">
      {{ errorText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { API_URL_PREFIX } from "@/config/consts";
import errors from "@/mixins/errors";
import Form from "./Form";
import { mapGetters } from "vuex";

export default {
  components: {
    Form
  },
  mixins: [errors],
  data() {
    return {
      formData: {},
      multiLine: true,
      snackbar: false,
      errorText: ""
    };
  },
  mounted() {
    this.fetchForm();
  },
  computed: {
    ...mapGetters(["getErrorText"])
  },
  methods: {
    async fetchForm() {
      try {
        const { data } = await this.$axios.get(
          `${API_URL_PREFIX}/landings/${this.getCurrentLandingId()}/forms/${this.getFormId()}`
        );

        this.formData = data;
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
        this.setErrors(response.data);
      }
    },
    async update(form) {
      try {
        form.landing = this.getCurrentLandingId();
        await this.$axios.patch(
          `${API_URL_PREFIX}/landings/${
            form.landing
          }/forms/${this.getFormId()}`,
          form
        );
        await this.$router.push({
          name: "Forms",
          query: { landing_id: form.landing }
        });
      } catch ({ response }) {
        this.snackbar = true;
        this.errorText = this.getErrorText(response);
        this.setErrors(response.data);
      }
    },
    getCurrentLandingId() {
      return this.$route.query.landing_id;
    },
    getFormId() {
      return this.$route.query.form_id;
    }
  }
};
</script>
